"use client";
import React, { HTMLAttributes } from "react";
import * as RadixDialog from "@radix-ui/react-dialog";
import cn from "classnames";
import Icon from "./icon";
import Button from "./button";

export interface ModalProps extends RadixDialog.DialogProps {
  trigger?: React.ReactElement<typeof Trigger>;
  dark?: boolean;
}

function Modal(props: ModalProps) {
  return (
    <>
      <RadixDialog.Root {...props}>
        {props.trigger ? (
          <RadixDialog.Trigger asChild>{props.trigger}</RadixDialog.Trigger>
        ) : undefined}
        <RadixDialog.Portal>
          {/* ROOT */}
          <div className="fixed inset-0 z-50">
            <RadixDialog.Overlay className="bg-black/25 data-[state=open]:animate-overlayShow flex justify-center items-center -z-[1] h-full backdrop-blur-sm">
              {/* SCROLLABLE */}
              <div className="flex justify-center items-center w-full h-full">
                <RadixDialog.Content className={`z-50 m-8 ${props.dark ? 'bg-secondary-100' : 'bg-surface'} overflow-x-hidden rounded-xl relative shadow-elevation-400 focus:outline-none max-h-[calc(100%_-_64px)] overflow-y-auto`}>
                  {props.children}
                </RadixDialog.Content>
              </div>
            </RadixDialog.Overlay>
          </div>
        </RadixDialog.Portal>
      </RadixDialog.Root>
    </>
  );
}

function Trigger(props: RadixDialog.DialogTriggerProps) {
  return <RadixDialog.Trigger {...props}>{props.children}</RadixDialog.Trigger>;
}

interface ModalHeaderProps {
  title?: string | JSX.Element;
  separator?: boolean;
  showUser?: boolean;
  onClose?: () => void;
}
function Header(props: ModalHeaderProps) {
  return (
    <>
      <div className="flex p-6 items-center flex-row justify-between gap-4">
        <div className="flex justify-center items-center">
        {props.title ? (
          <>
          
          <RadixDialog.Title className="text-headline-bold uppercase">
            {props.title}
          </RadixDialog.Title>
          {props.showUser && <></>}
        </>
        ) : undefined}
        </div>
        <RadixDialog.Close
          asChild
          onClick={() => props.onClose && props.onClose()}
        >
          <Button variant="circle" color="tertiary">
            <Icon name="close" size="sm" />
          </Button>
        </RadixDialog.Close>
      </div>
      {props.separator && <hr className="border-surface-600" />}
    </>
  );
}

function Footer(props: HTMLAttributes<HTMLDivElement>) {
  return (
    <>
      <hr />
      <div
        {...props}
        className={cn(
          `flex justify-between items-center px-6 pb-6 pt-2`,
          props.className
        )}
      >
        <RadixDialog.Close asChild>
          <Button ghost color="tertiary">
            Back
          </Button>
        </RadixDialog.Close>
      </div>
    </>
  );
}

Modal.Trigger = Trigger;
Modal.Header = Header;
Modal.Footer = Footer;
export default Modal;
